import client, {MutationOptions, QueryOptions} from "@irati/utils/services/apollo"
import {
  MutationCreateProductArgs,
  MutationUpdateProductArgs,
  Product,
  QueryProductArgs,
  QueryProductsArgs,
  QueryProductsSearchArgs,
  QueryProductSuppliersArgs
} from "@irati/types"
import listFormat, {ListFormatArray} from "@irati/utils/services/graph/utils/listFormat"
import {omit} from "lodash"
import productQuery, {productKey} from "./queries/getProduct"
import productsQuery, {productsKey} from "./queries/getProducts"
import productsSearchQuery, {productsSearchKey} from "./queries/productsSearch"
import createProduct, {createProductKey} from "./mutation/createProduct"
import updateProduct, {updateProductKey} from "./mutation/updateProduct"
import suppliersSearch, {suppliersSearchKey} from "./queries/productSuppliers"
import commissionGroupsQuery, {commissionGroupsKey} from "./queries/getCommissionGroups"

class ProductService {
  list = (args?: QueryProductsArgs, options: QueryOptions = {}): Promise<ListFormatArray<Product>> => {
    const variables = {...args} // clean inputs?
    return client.query({...options, query: productsQuery, variables}).then(({data}) => {
      return listFormat(data[productsKey])
    })
  }

  searchProduct = (args?: QueryProductsSearchArgs, options: QueryOptions = {}): Promise<ListFormatArray<Product>> => {
    const variables = {...args}
    return client.query({...options, query: productsSearchQuery, variables}).then(({data}) => {
      return listFormat(data[productsSearchKey])
    })
  }

  get = (args: QueryProductArgs, options: QueryOptions = {}): Promise<Product> => {
    const variables = {...args} // clean inputs?
    return client.query({...options, query: productQuery, variables}).then(({data}) => {
      return data[productKey]
    })
  }

  createProduct({data}: MutationCreateProductArgs, options: MutationOptions = {}): Promise<Product> {
    return client.mutate({...options, mutation: createProduct, variables: {data}}).then(({data: responseData}) => {
      return responseData[createProductKey]
    })
  }

  updateProduct({data}: MutationUpdateProductArgs, options: MutationOptions = {}): Promise<Product> {
    const args = omit(data, "externalIdentifier")

    return client
      .mutate({
        ...options,
        mutation: updateProduct,
        variables: {data: args}
      })
      .then(({data: responseData}) => {
        return responseData[updateProductKey]
      })
  }

  productSuppliers({search}: QueryProductSuppliersArgs, options: QueryOptions = {}): Promise<any> {
    const variables = {search}
    return client.query({...options, query: suppliersSearch, variables}).then(({data}) => {
      return data[suppliersSearchKey]
    })
  }

  commissionGroups(variables: any, options: QueryOptions = {}): Promise<any> {
    return client.query({...options, query: commissionGroupsQuery, variables}).then(({data}) => {
      return data[commissionGroupsKey]
    })
  }
}

export default new ProductService()
